import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../components/AppDrawer';
import OfferingForm, { type OfferingFormFieldValues } from './OfferingForm';
import type { OfferingDetail, OfferingFormValues } from '../types';

export interface OfferingFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  offeringId: string | null;
  offering: OfferingDetail | null | undefined;
  loadingOffering: boolean;
  onSave: (values: OfferingFormValues) => void;
  saving: boolean;
}

const OfferingFormDrawer: React.FC<OfferingFormDrawerProps> = ({
  open,
  onClose,
  mode,
  offering,
  loadingOffering,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<OfferingFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ status: 0 });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add offering' : 'Edit offering';

  return (
    <Drawer
      title={title}
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      destroyOnClose
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingOffering) && (
        <OfferingForm
          form={form}
          initialValues={mode === 'edit' ? offering ?? null : null}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default OfferingFormDrawer;
